import './Pricing.css';
import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { withTranslate } from 'react-redux-multilingual';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import FadeInSection from '../../blocks/FadeInSection/FadeInSection';

function Pricing(props) {
    const { translate } = props;

    const tiers = [
        {
          title: translate('standard'),
          price: translate('standardprice'),
          description: translate('standarddescription'),
          buttonText: translate('tryforfree'),
          buttonVariant: 'contained',
          buttonColor: 'success',
          buttonHref: '/register/standard',
        },
        {
          title: translate('premium'),
          price: translate('premiumprice'),
          description: translate('premiumdescription'),
          buttonText: translate('bynow'),
          buttonVariant: 'contained',
          buttonColor: 'info',
          buttonHref: '/register/premium',
        },
        {
          title: translate('enterprise'),
          price: translate('enterpriseprice'),
          description: translate('enterprisedescription'),
          buttonText: translate('bynow'),
          buttonVariant: 'contained',
          buttonColor: 'info',
          buttonHref: '/register/enterprise',
        },
        {
            title: translate('cooperation'),
            price: translate('cooperationprice'),
            description: translate('cooperationdescription'),
            buttonText: translate('contact'),
            buttonVariant: 'contained',
            buttonColor: 'warning',
            buttonHref: '/contact',
          },
    ];

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])

    return (
        <div className='pricing'>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='section-1'>
                    <Box sx={{ p: 2 }}>
                        <FadeInSection>
                            <Typography variant="h2" gutterBottom component="h1" sx={{ fontWeight: "500", pt: 1, pb: 5 }}>
                                {translate('pricing')}
                            </Typography>
                            <Typography variant="body1" gutterBottom component="p" sx={{ color: "#586978", fontSize: "1.2rem", lineHeight: "2rem", pb: 5 }}>
                                {translate('pricingdescription')}
                            </Typography>
                        </FadeInSection>
                        <FadeInSection>
                            <Box sx={{ mt: 5, display: "flex", justifyContent: "center", gap: 2 }}>
                                <Button variant="contained" color="success" endIcon={<ChevronRightIcon />} component={Link} to="/register/standard">
                                {translate('tryforfree')}
                                </Button>
                                <Button variant="outlined" color="success" endIcon={<ChevronRightIcon />} component={Link} to="/contact">
                                {translate('contactsales')}
                                </Button>
                            </Box>
                        </FadeInSection>
                    </Box>
                </Box>
            </Container>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box sx={{ px: { xs: 2, md: 20 } }}>
                    <Grid container spacing={4}>
                    {tiers.map((tier) => (
                        <Grid key={tier.title} item xs={12} md={6} lg={3}>
                            <FadeInSection>
                                <Box className="price-card">
                                    <Typography variant="h4" gutterBottom component="div" color="primary">
                                        {tier.title}
                                    </Typography>
                                    <Divider sx={{ my: 2 }} />
                                    <Box
                                        sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'baseline',
                                        mb: 2,
                                        }}
                                    >
                                        {tier.price &&
                                        <>
                                            <Typography component="h2" variant="h3" color="text.primary">{tier.price}</Typography>
                                            <Typography variant="h6" color="text.secondary">/{translate('month')}</Typography>
                                        </>}
                                    </Box>
                                    <ul style={{ paddingLeft: "20px" }}>
                                        {tier.description.map((line) => (
                                        <Typography
                                            component="li"
                                            variant="subtitle1"
                                            align="center"
                                            key={line}
                                            className="option-in-package"
                                        >
                                            <CheckCircleIcon color='primary'/>
                                            {line}
                                        </Typography>
                                        ))}
                                    </ul>
                                    <Box>
                                        {tier.buttonHref === '/register/standard' &&
                                        <Typography variant="caption" component="div">
                                            {translate('freeupto30daysnocreditcardrequired')}
                                        </Typography>}
                                        <Button sx={{ mt: 2 }} variant={tier.buttonVariant} color={tier.buttonColor} disableElevation endIcon={<ChevronRightIcon />} component={Link} to={tier.buttonHref}>
                                            {tier.buttonText}
                                        </Button>
                                    </Box>
                                </Box>
                            </FadeInSection>
                        </Grid>
                    ))}
                    </Grid>
                </Box>
            </Container>
        </div>
    );
}
export default withTranslate(Pricing);